//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import IconArrow from '../components/IconArrow.vue';

export default {
	name: 'PageBanner',

	components: { IconArrow: IconArrow },

	props: {
		image: {
			type: String,
			default: ''
		},

		video: {
			type: Array
		},

		heading: {
			type: String,
			default: ''
		},

		caption: {
			type: String,
			default: ''
		}
	},

	data: function data() {
		return {
			imageLoaded: false,
			startTime: 0
		};
	},


	computed: {
		isSafari: function isSafari() {
			return process.browser ? window.navigator.userAgent.includes('iPhone') && this.mobile : false;
		},
		mobile: function mobile() {
			return this.$route.query.mobile;
		},
		hasContent: function hasContent() {
			return this.heading && this.caption;
		},
		hasMedia: function hasMedia() {
			return this.image || this.video;
		},
		supportObjectFit: function supportObjectFit() {
			if (!process.server) {
				return 'objectFit' in document.body.style;
			}

			return true;
		}
	},

	methods: {
		fitCover: function fitCover() {
			if (this.supportObjectFit) return;

			var videoRatio = this.$refs.cover.videoWidth / this.$refs.cover.videoHeight,
			    viewportRatio = this.$refs.banner.clientWidth / this.$refs.banner.clientHeight;

			this.$refs.cover.style.width = viewportRatio >= videoRatio ? '100%' : 'auto';
			this.$refs.cover.style.height = viewportRatio <= videoRatio ? '100%' : 'auto';
		},
		onImageLoad: function onImageLoad() {
			var _this = this;

			var time = 600 - (new Date() - this.startTime);

			if (time < 0) time = 0;

			setTimeout(function () {
				return _this.imageLoaded = true;
			}, time);
		},
		onImage: function onImage() {
			if (this.image) {
				this.imageLoaded = false;

				var img = new Image();

				this.startTime = new Date();

				img.onload = this.onImageLoad;
				img.src = this.image;
			}
		}
	},

	watch: {
		image: function image(val) {
			this.onImage();
		}
	},

	mounted: function mounted() {
		if (this.video && !this.supportObjectFit) {
			window.addEventListener('resize', this.fitCover);
		}

		this.onImage();
	},
	destroyed: function destroyed() {
		window.removeEventListener('resize', this.fitCover);
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PageBanner.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PageBanner.vue
// module chunks = 0 1 2